// extracted by mini-css-extract-plugin
export default {"preloader":"preloader_preloader__oRmkc","gif":"preloader_gif__8IFnf"};